export default __webpack_public_path__ + "ab01f4ce88603b183790b6f8a4c34872.png";